import { v4 as uuidv4 } from 'uuid';
import { deepClone, isBlank } from "@/common/utils";

export const location = {
  state: {
    locations: {
      /*
      uuid: {
        uuid: // uuid
        name: null,
        type: "building" // "area", "level", "location"
        onwer_uuid: // owner's uuid, null if none
        description: null,
        size: null // floor area,
        size_unit: "m2"
      }
      */
    },
    site_locations: {
      /*
      site_uuid: {
        location_uuid: null
      }
      */
    }
  },
  mutations: {
    insertLocation(state, new_location) {
      state.locations[new_location.uuid] = new_location;
    },

    insertSiteLocation(state, args) {
      if (state.site_locations[args.siteUUID]) {
        state.site_locations[args.siteUUID].push(args.locationUUID);
      } else {
        state.site_locations[args.siteUUID] = [ args.locationUUID ];
      }
    },

    updateLocation(state, payload) {
      const location_uuid = payload.uuid;
      //const location = state[location_uuid];
      if (state.locations[location_uuid]) {
        state.locations[location_uuid] = payload;
      }
    },

    removeLocation(state, location_uuid) {
      const location = state.locations[location_uuid];
      if (location) {
        const site_uuid = location.site_uuid
        delete state.locations[location_uuid];
        state.site_locations[site_uuid] = state.site_locations[site_uuid].filter(function(aUUID) {
          return aUUID !== location_uuid;
        });

        if (isBlank(state.site_locations[site_uuid])) {
          delete state.site_locations[site_uuid]
        }        
      }
    },

    removeSiteLocations(state, site_uuid) {
      const location_uuids = state.site_locations[site_uuid];
      location_uuids.forEach(function(location_uuid) {
        delete state.locations[location_uuid];
      });
      delete state.site_locations[site_uuid];
    },

    removeAllLocations(state) {
      state.locations = {};
      state.site_locations = {};
    }
  },
  actions: {
    addLocation({ commit }, payload) {
      console.log("Inside location.mondule.js, addLocation(), payload ==> ", payload);
      let new_location = payload;
      // if it's a new location created locally, generate uuid and timestamps
      if (!new_location.uuid) {
        const newUUID = uuidv4();
        new_location.uuid = newUUID;  
        new_location.created_at = new Date().toISOString();
        new_location.updated_at = new Date().toISOString();
      }
      commit("insertLocation", new_location);
      commit("insertSiteLocation", { siteUUID: new_location.site_uuid, locationUUID: new_location.uuid });
      return new_location.uuid;
    },

    async quickAddLocation( { dispatch }, location ) {
      console.log("Inside location.mondule.js, quickAddLocation(), location ==> ", location);
      if (location.location_name) {
        let ownerUUID;

        if (location.level_name) {
          ownerUUID = await dispatch('quickAddLevel', location);
        } else if (location.level_uuid) {
          ownerUUID = location.area_uuid;
        } else if (location.area_name) {
          ownerUUID = await dispatch('quickAddArea', location);
        } else if (location.area_uuid) {
          ownerUUID = location.area_uuid;
        } else if (location.building_name) {
          ownerUUID = await dispatch('quickAddBuilding', location);
        } else if (location.building_uuid) {
          ownerUUID = location.building_uuid;
        } 

        const newLocation = {
          type: "Location",
          site_uuid: location.site_uuid,
          name: location.location_name,
          owner_uuid: ownerUUID
        }

        return dispatch("addLocation", newLocation);
      } else if (location.location_uuid) {
        // no need to quick add
        return location.location_uuid;
      } else {
        return dispatch('quickAddLevel', location);
      }
    },

    async quickAddLevel( { dispatch }, location ) {
      console.log("Inside location.mondule.js, quickAddLevel(), location ==> ", location);
      if (location.level_name) {
        let ownerUUID;

        if (location.area_name) {
          ownerUUID = await dispatch('quickAddArea', location);
        } else if (location.area_uuid) {
          ownerUUID = location.area_uuid;
        } else if (location.building_name) {
          ownerUUID = await dispatch('quickAddBuilding', location);
        } else if (location.building_uuid) {
          ownerUUID = location.building_uuid;
        } 

        const newLocation = {
          type: "Level",
          site_uuid: location.site_uuid,
          name: location.level_name,
          owner_uuid: ownerUUID
        }

        return dispatch("addLocation", newLocation);
      } else if (location.level_uuid) {
        // no need to quick add
        return location.level_uuid;
      } else {
        return dispatch('quickAddArea', location);
      }
    },

    async quickAddArea( { dispatch }, location ) {
      console.log("Inside location.mondule.js, quickAddArea(), location ==> ", location);
      if (location.area_name) {
        let ownerUUID;

        if (location.building_name) {
          ownerUUID = await dispatch('quickAddBuilding', location);
        } else if (location.building_uuid) {
          ownerUUID = location.building_uuid;
        } 

        const newLocation = {
          type: "Area",
          site_uuid: location.site_uuid,
          name: location.area_name,
          owner_uuid: ownerUUID
        }
        
        return dispatch("addLocation", newLocation);
      } else if (location.area_uuid) {
        // no need to quick add
        return location.area_uuid;
      } else {
        return dispatch('quickAddBuilding', location);
      }
    },

    async quickAddBuilding( { dispatch }, location ) {
      console.log("Inside location.mondule.js, quickAddBuilding(), location ==> ", location);
      if (location.building_name) {
        const newLocation = {
          type: "Building",
          site_uuid: location.site_uuid,
          name: location.building_name
        }
        return dispatch("addLocation", newLocation);     
      } else if (location.building_uuid) {
        // no need to quick add
        return location.building_uuid;
      } else {
        return null;
      }
    },

    modifyLocation({ commit }, payload) {
      const location = deepClone(payload);
      location.updated_at = new Date().toISOString();
      commit("updateLocation", location);
    },

    timestampLocationSync({ commit, getters }, location_uuid) {
      const location = getters.getLocationByUUID(location_uuid);
      location.sync_on = new Date().toISOString();
      commit("updateLocation", location);
    },

    deleteLocation({ commit, dispatch }, location_uuid) {
      dispatch('deleteNotesByOwner', location_uuid);
      dispatch('deleteImagesByOwner', location_uuid);
      dispatch('deleteEmosByOwner', location_uuid);
      dispatch("nullifyAssetLocations", location_uuid);
      commit("removeLocation", location_uuid);
    },

    deleteLocationsBySite({ getters, dispatch }, site_uuid) {
      const all_locations = getters.getLocationsBySiteUUID(site_uuid);
      all_locations.forEach(function(location) {
        dispatch('deleteLocation', location.uuid);
      })
    },     

    clearAllLocations({ commit }) {
      commit("removeAllLocations");
    }
  },
  getters: {
    allLocations(state) {
      return state.locations;
    },

    allSiteLocations(state) {
      return state.site_locations
    },

    getLocationByUUID(state) {
      return function(uuid) {
        const location = state.locations[uuid];
        return location ? deepClone(location) : null;
      }
    },

    getLocationTypeByUUID(state) {
      return function(uuid) {
        const location = state.locations[uuid];
        return location ? location.type : null;
      }
    },

    getLocationsBySiteUUID(state, getters) {
      return function(siteUUID) {
        const locationUUIDs = state.site_locations[siteUUID];
        if (locationUUIDs) {
          return locationUUIDs.map(function(locationUUID) {
            return getters.getLocationByUUID(locationUUID);
          });
        } else {
          return []
        }
      }
    },

    getLocationByName(state) {
      return function(giveName) {
        const location = Object.values(state.locations).find(function(location) {
          return (location.name == giveName)
        });
        return deepClone(location);
      }
    },

    // Get Locations By Site UUID without Owner
    getRootLocationsBySiteUUID(state, getters) {
      return function(siteUUID) {
        const allLocations = getters.getLocationsBySiteUUID(siteUUID);
        console.log("Inside location.module.js, getRootLocationsBySiteUUID, allLocations ==> ", allLocations);
        const locations = allLocations.filter(function(location) {
          return (!location.owner_uuid)
        });
        return locations.map(location => deepClone(location));
      }
    },

    // get all locations owned by the give owner
    getLocationByOwner(state, getters) {
      return function(owner) {
        const allLocations = getters.getLocationsBySiteUUID(owner.site_uuid);
        const locations = allLocations.filter(function(location) {
          return (location.owner_uuid == owner.uuid);
        });
        return locations.map(location => deepClone(location));
      }
    },

    nbLocationsBySite() {
      return function(siteUUID) {
        return this.getLocationsBySiteUUID(siteUUID).length
      }
    }

  }
}